module.exports = __webpack_public_path__ + "assets/6211ef26bc1e32890756fb6b639a13cc.mp3";